module.exports = __webpack_public_path__ + "img/box-1-zh.31148dc3.png";